export enum EdbDispositionDateType {
  AT_LATEST,
  EXACT,
}

export enum DispositionType {
  ON_DOCKYARD = "Chantier",
  NEAREST_WAREHOUSE = "Entrepôt le plus proche",
  SUBCONTRACTED_WAREHOUSE = "Entrepôt sous-traitant",
  OTHER_PLACE = "Autre lieu",
  COLLECTED = "Collecte",
}

export enum EdbStatus {
  WAITING = "waiting",
  REFUSED = "refused",
  CART_CREATED = "cart_created",
  CART_VALIDATED = "cart_validated",
  PREPARATION_IN_PROGRESS = "prep_in_progress",
  PREPARATION_AVAILABLE = "prep_avalaible",
  SHIP_IN_PROGRESS = "ship_in_progress",
  DELIVERED_WAREHOUSE = "delivered_warehouse",
  COLLECTED = "collected",
}

export type DispositionAddressType = {
  dispositionAdress?: string;
  dispositionAdress2?: string;
  dispositionPostalCode?: string;
  dispositionCity?: string;
  dispositionCountry?: string;
};

export type EDB = {
  _id: string;
  company: string;
  companyDisable: boolean;
  createdAt: Date | string;
  createdBy: string;
  // TODO: Address mispelling
  dispositionAdress: string;
  dispositionAdress2: string;
  dispositionCity: string;
  dispositionCountry: string;
  dispositionDate: Date | string;
  dispositionDateIsExact: boolean;
  scheduledInterventionDate?: Date | string | null;
  dispositionPostalCode: string;
  dispositionType: DispositionType;
  dispositionPlace?: string;
  dockyard: string;
  dockyardDisable: boolean;
  edbId: string;
  analyticCode: string;
  emailContactRecovery: string;
  entrepotName: string;
  firstnameContactRecovery: string;
  isDisable: boolean;
  lastnameContactRecovery: string;
  medias: Array<any>;
  notes: string;
  phoneContactRecovery: string;
  /**
   * @deprecated
   * preparationType must alway be "Préparation pour mise à disposition" --> "Préparation & restockage" is not used anymore
   */
  preparationType: string;
  products: Array<string> | Array<any>;
  project: any;
  projectDisable: boolean;
  intervenantCompany: string;
  intervenantContact: string;
  status: EdbStatus;
  approveDesc?: string;
  refusedAt?: Date | string;
  approvedAt?: Date | string;
  updatedAt: Date | string;
  transferGmao: boolean;
};
